import Vue from "vue";
import App from "./App.vue";
import {
  BootstrapVue
} from "bootstrap-vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueSmoothScroll from "vue2-smooth-scroll";
import Vuelidate from "vuelidate";
import VueCardFormat from "vue-credit-card-validation";
import VueMeta from 'vue-meta';

import router from "./router";
//import titleMixin from "./assets/js/titleMixin";

//Vue.mixin(titleMixin);

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);
Vue.use(BootstrapVue);
Vue.use(VueSmoothScroll);
Vue.use(Vuelidate);
Vue.use(VueCardFormat);
Vue.use(VueMeta);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
